<h2 mat-dialog-title>{{ data.id ? 'Edit Availability' : 'Add Availability' }}</h2>
<div mat-dialog-content>
  <form #availabilityForm="ngForm">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Day of Week</mat-label>
      <mat-select [(ngModel)]="data.dayOfWeek" name="dayOfWeek" required (selectionChange)="validateTimes()">
        <mat-option *ngFor="let day of data.daysOfWeek" [value]="day.value">
          {{ day.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <div class="time-fields">
      <mat-form-field appearance="outline">
        <mat-label>Start Time</mat-label>
        <input matInput type="time" [(ngModel)]="data.startTime" name="startTime" required (change)="validateTimes()">
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>End Time</mat-label>
        <input matInput type="time" [(ngModel)]="data.endTime" name="endTime" required (change)="validateTimes()">
      </mat-form-field>
    </div>
    
    <div *ngIf="!isValid" class="validation-error">
      {{ validationMessage }}
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!availabilityForm.valid || !isValid">
    Save
  </button>
</div>
